import {
  Box,
  Inline,
  Link as SenekitLink,
  useWindowSize
} from "@seneca/senekit";

import { Link } from "common/types/routing";

import Logo from "features/common/logos/Logo";

import SidebarToggle from "../../../SidebarToggle/SidebarToggle";
import SidebarHeaderExitButton from "../SidebarHeaderExitButton/SidebarHeaderExitButton";

type Props = {
  quitLink: Link;
  sidebarOpen: boolean;
  handleToggle: () => void;
};

export const COURSE_CONTENT_BREAKPOINT = 1020;

export default function SidebarHeaderUpper({
  quitLink,
  sidebarOpen,
  handleToggle
}: Props) {
  const { width } = useWindowSize();

  const windowBelowBreakpoint = width <= COURSE_CONTENT_BREAKPOINT;

  return (
    <Box paddingBottom="12">
      <Inline justifyContent="space-between" alignItems="center">
        {windowBelowBreakpoint ? (
          <>
            <SidebarHeaderExitButton quitLink={quitLink} />
            <SenekitLink to={quitLink}>
              <Logo height="26px" />
            </SenekitLink>
            <SidebarToggle onClick={handleToggle} sidebarOpen={sidebarOpen} />
          </>
        ) : (
          <>
            <SenekitLink to={quitLink}>
              <Logo height="26px" />
            </SenekitLink>
            <SidebarHeaderExitButton quitLink={quitLink} />
          </>
        )}
      </Inline>
    </Box>
  );
}
